<template>
  <div class="py-8 relative">
    <FormTemplate title="Freelancer Packages">
      <template #main>
        <div class="flex flex-wrap row-wrapper">
          <div
            v-for="(bundle, index) in bundles"
            :key="index"
            :class="bundle.classes"
          >
            <BundleBlock v-bind="bundle"></BundleBlock>
          </div>
        </div>
      </template>
    </FormTemplate>
  </div>
</template>

<script>
  import FormTemplate from "../shared/FormTemplate";
  import BundleBlock from "../shared/BundleBlock";

  export default {
    name: "Freelancer",
    components: {
      FormTemplate,
      BundleBlock
    },
    data() {
      return {
        bundles: [
          {
            title: "Cloud Sites + Spam Gateway",
            price: 11.0,
            description:
              "An entry-level package to get you up and running efficiently with email and web hosting.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "Cloud Sites + Office 365",
            price: 14.0,
            description:
              "All the communication & collaboration you need, combined with state of the art website hosting.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "The Everything Bundle",
            price: 19.0,
            description:
              "The bundle to get you where you need to be, spam filtering, collaboration, and web hosting.",
            link: "",
            classes: "flex w-full justify-center"
          }
        ]
      };
    }
  };
</script>
